export default "__VITE_ASSET__DNk3ZBZf__"